<template>
  <div
    ref="container"
    class="monaco-editor"
  ></div>
</template>

<script>
import * as monaco from "monaco-editor";
import "monaco-editor/esm/vs/basic-languages/javascript/javascript.contribution";

export default {
  name: "monaco",
  props: {
    opts: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      // 主要配置
      defaultOpts: {
        value: "", // 编辑器的值
        theme: "vs-dark", // 编辑器主题：vs, hc-black, or vs-dark
        roundedSelection: false, // 右侧不显示编辑器预览框
        autoIndent: true, // 自动缩进
        language: "javascript",
        automaticLayout: true, // 自适应布局
        overviewRulerBorder: false, // 不要滚动条的边框
        scrollBeyondLastLine: true, // 取消代码后面一大段空白
        fontSize: "18px",
        folding: true,
        foldingStrategy: "indentation", // 代码可分小段折叠
        minimap: {
          enabled: false, // 不要小地图
        },
      },
    };
  },
  watch: {
    opts: {
      handler(n) {
        this.init();
      },
      deep: true,
    },
  },
  mounted() {
    this.init();
  },
  unmounted() {
    this.uninit();
  },
  methods: {
    init() {

      this.uninit();

      // 初始化container的内容
      this.editorOptions = Object.assign(this.defaultOpts, this.opts); 
      
      // 生成编辑器对象
      this.monacoEditor = monaco.editor.create(
        this.$refs.container,
        this.editorOptions
      ); 
      
      // 编辑器内容发生改变时触发
      this.monacoEditor.onDidChangeModelContent(() => {
        this.$emit("change", this.monacoEditor.getValue());
      });
    },
    uninit() {
      if (this.monacoEditor != null) {
        this.monacoEditor.getModel().dispose();
        this.monacoEditor.dispose();
      }
    },
    getVal() {
      return this.monacoEditor.getValue();
    },
  },
};
</script>